<div class="slider-dots" [ngClass]="{'-invisible': disabled || dotsItems?.length < 2}">
    <div class="slider-dots__dot" [ngClass]="{'is-active': dot === activeId, 'is-disabled': disabled}"
        *ngFor="let dot of dotsItems" (click)="handleDotClick($event, dot)" [id]="'dot-'+dot"></div>
</div>